export default __webpack_public_path__ + "static/media/background.c5687a63.webp";